import { Money, NominalMoney } from "./Money";

export type ProfitAndLoss = NominalMoney<"ProfitAndLoss">;
export const asProfitAndLoss = (value: Money) => value as unknown as ProfitAndLoss;
